'use strict';

export * from "./colors.js";
export * from "./filter.js";
export * from "./font.js";
export * from "./margins.js";
export * from "./paddings.js";
export * from "./shadows.js";
//# sourceMappingURL=index.js.map